// custom.js


function initcartFormUtils() {
	document.addEventListener('alpine:init', () => {
		// console.log('Alpine.js è pronto e sto registrando cartFormUtils!');

			window.Alpine.data('cartFormUtils', ({
				cartRequestInvoice,
				cartIsCompany,
				cartCf,
				cartPIva,
				cartSdi,
				cartPec
			}) => ({
				// buttonEnabled: false,
				requestInvoice: cartRequestInvoice || false,
				isCompany: cartIsCompany || false,
				cf: cartCf || '',
				pIva: cartPIva || '',
				sdi: cartSdi || '',
				pec: cartPec || '',

				//

				get submitDisabled () {
					// if (!this.buttonEnabled) return true;
					if (this.requestInvoice && !this.cf && !this.isCompany) return true;
					if (this.requestInvoice && this.isCompany && !this.pIva) return true;
					return false;
				},
				get requestInvoiceAttribute () { return this.requestInvoice ? 'yes' : 'no' },
				get isCompanyAttribute () { return this.isCompany ? 'yes' : 'no' },
				get cfAttribute () { return this.requestInvoice ? this.cf : '' },
				get pIvaAttribute () { return this.requestInvoice && this.isCompany ? this.pIva : '' },
				get sdiAttribute () { return this.requestInvoice && this.isCompany ? this.sdi : '' },
				get pecAttribute () { return this.requestInvoice && this.isCompany ? this.pec : '' },
			}));
	});
}

newsletterFormUtils();

function newsletterFormUtils() {
		document.addEventListener('alpine:init', () => {

			const inintialResponse = {
				success: false,
				error: false,
				error_messages: [],
				errors: {},
			};

			const ERROR_GENERIC = 'generic';

			window.Alpine.data('newsletterFormUtils', ({
			}) => ({

				ERROR_GENERIC,

				loading: false,

				response: { ...inintialResponse },

				getErrorMessage(err) {
					return window.SN.diz.form_errors[err] ? Utils.stringFromHtmlEntities(window.SN.diz.form_errors[err]) : '';
				},

				onSubmit($event) {
					$event.preventDefault();

					this.loading = true;
					this.response = { ...inintialResponse };
					const formData = new FormData($event.target);

					const jsonData = Object.fromEntries(formData.entries());

					if ($event.target.action) {
						fetch($event.target.action, {
							method: 'POST',
							headers: {
									'Content-Type': 'application/json',
									'Accept': 'application/json'
							},
							body: JSON.stringify(jsonData),
						})
						.then(response => response.json())
						.then(response => {

							// Get the response, and if there's any error, return
							this.response = {
								...inintialResponse,
								...response,
							};

							if (this.response.error) return;
							if (this.response.error_messages.length) return;

							if(response.success) {
								const formElement = $event.target;
								const emailInput = formElement.querySelector('[name="newsletter_email"]');
								const email = emailInput?.value;

								const dataLayerEvent = {
									event: 'form_newsletter',
									event_data: {
										id: formElement.id || 'NewsletterForm',
										url: formElement.action,
										email: email,
									},
								};

								console.log('Dati inviati al dataLayer:', dataLayerEvent);

								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push(dataLayerEvent);

								formElement.reset();
							}
						})
						.catch(( e ) => {
							// On any generic error, remove the loader anyway and show the
							// "generic" error message
							this.response = { ...inintialResponse };
							this.response.error = ERROR_GENERIC;
						})
						.finally(() => {
							// Always disable `loading`
							this.loading = false;
						});
					} else {
						setTimeout(() => {
							this.response = {
								success: true,
								error: false,
								errors: {},
							};

							this.loading = false;
						}, 1000)
					}
				},

				captcha() {
					// Set a `ready` state after loading, or not loading, the CAPTHCA
					// If the we can't start the CAPTCHA, set immediately the `ready` state
					// and return
					if (!window.Shopify.captcha) {
						this.ready = true;
						return;
					}

					// Otherwise, load the CAPTCHA and, when it's loaded, make the form sumbittable
					// window.Shopify.captcha.protect(this.$refs.form, () => {
						this.ready = true;
					// });
				},

				//

				init() {
					// Add the Shopify CAPTCHA
					this.captcha();
				},

			}));
		});
}

